import React, { useRef, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { AuthenticationActions } from '@galo-monitor/stores/authentication'
import ResetPasswordForm from '@galo-monitor/web-containers/forms/auth/ResetPasswordForm'
import { Item } from '@galo-monitor/web-containers/layouts/GuestLayout/theme'

const ResetPasswordScreen = () => {
  const formRef = useRef(null)

  const dispatch = useCallback(useDispatch())

  useEffect(
    () => {
      dispatch(AuthenticationActions.resetAuthentication())
    },
    [dispatch]
  )

  return (
    <Item>
      <ResetPasswordForm ref={ formRef } />
    </Item>
  )
}

export default ResetPasswordScreen
